import { Button, Flex, SizeScale, usePlatformProps } from '@acsbe/ui';

export interface SubscribePlanButtonProps {
  isRenew: boolean;
  isUpgrade: boolean;
  isReactivate: boolean;
  disabled: boolean;
  onClick: () => {};
  gap?: SizeScale | number;
  dataMixpanel?: string;
}

export const SubscribePlanButton = ({
  isRenew,
  isUpgrade,
  isReactivate,
  disabled,
  onClick,
  gap = 4,
  dataMixpanel,
}: SubscribePlanButtonProps) => {
  const p = usePlatformProps();

  return (
    <Flex
      align="center"
      gap={gap}
      self="stretch"
      // {...p.uptoMobile({
      //   stretch: true,
      //   self: 'stretch',
      // })}
    >
      <Button
        fullWidth
        disabled={disabled}
        scale="primary"
        onClick={onClick}
        data-mixpanel={dataMixpanel}
      >
        {isRenew
          ? 'Renew'
          : isUpgrade
            ? 'Upgrade'
            : isReactivate
              ? 'Reactivate'
              : 'Buy'}{' '}
        Plan
      </Button>
    </Flex>
  );
};
